import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/dialog";

@Component({
  selector: "app-edit-lexicon-dialog",
  templateUrl: "./edit-lexicon-dialog.component.html",
  styleUrls: ["./edit-lexicon-dialog.component.scss"],
  standalone: false,
})
export class EditLexiconDialogComponent implements OnInit {
  wordControl: UntypedFormControl;
  valueControl: UntypedFormControl;
  lexiconForm: UntypedFormGroup;

  boosterOptions = ["INCREMENT", "DECREMENT"];
  sentimentValueOptions = [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5];
  valueOptions = [];

  constructor(
    public dialogRef: MatDialogRef<EditLexiconDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.wordControl = new UntypedFormControl(
      this.data.originalWord?.toLowerCase() || "",
      [Validators.required],
    );

    // Convert input to lowercase as user types
    this.wordControl.valueChanges.subscribe((value) => {
      if (value && typeof value === "string") {
        const lowerValue = value.toLowerCase();
        if (value !== lowerValue) {
          this.wordControl.setValue(lowerValue, { emitEvent: false });
        }
      }
    });

    if (this.data.type) {
      const defaultValue = this.data.valueString ? this.boosterOptions[0] : 0;
      this.valueControl = new UntypedFormControl(
        this.data.originalValue || defaultValue,
        [Validators.required],
      );
      this.lexiconForm = new UntypedFormGroup({
        wordControl: this.wordControl,
        valueControl: this.valueControl,
      });
      this.valueOptions = this.data.valueString
        ? this.boosterOptions
        : this.sentimentValueOptions;
    } else {
      this.lexiconForm = new UntypedFormGroup({
        wordControl: this.wordControl,
      });
    }
  }

  confirm(): void {
    if (this.valueControl) {
      const word = this.wordControl.value?.toLowerCase() || "";
      this.data.onConfirm(word, this.valueControl?.value);
    }
  }
}
